/* eslint-disable */  
<template>
    <section>
        <div v-if="!user" >
            <div class="register-form-container">
                <!-- <form id="head"  novalidate autocomplete="off"> -->
                    <br> <br> <br> <br> <br>
                <div class="heading">
                <span>Please Loging First.....</span>
                
                <h3><router-link class="btn dark"  to="/login">Login</router-link></h3>
                </div>
          
            <h3><b></b></h3>
            </div>
            
                 <!-- </form> -->
            
        </div>
        
        <div v-else  class="register-container">
        <div class="register-form-container">
 
            <form @submit.prevent="submitForm" id="taxInvoince"  novalidate autocomplete="off">
                <pre>DateTime :{{ new Date().toLocaleString()}}</pre>
                <div class="heading">
                <span>Local Government Online Payment Management System</span>
                    <h3><b>Payment Reciept</b></h3>
                 </div>
                <div  class="table-responsive">
                    <h5 v-if="theSabhaData && theSabhaData[0]">{{ theSabhaData[0].sb_address }}</h5> 
                    <h5 v-if="theSabhaData && theSabhaData[0]">Tel:{{ theSabhaData[0].sb_contact}}, Fax:{{ theSabhaData[0].fax}}</h5> 
                  <h6>Invoice No : &nbsp;{{ InvouceNum }} </h6>
                <table class="table">
        
                    <tbody>
                        <tr>
                            <td class="bg-light-gray"><label for="Uname"><b>Your NIC | හැඳුනුම්පත් අංකය</b></label></td>
                            <td > <label for="Uname">{{ user.cus_nic }} </label></td>
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label for="Uname"><b>Your Name | නම</b></label></td>
                            <td ><label for="Uname">{{ user.cus_name }}</label></td>
                        </tr>
                       
                     
                        <tr>
                            <td class="bg-light-gray"> <label for="month"><b>Pay Amount | ගෙවන මුදල(රු.) </b></label></td>
                            <td ><label for="Uname">{{ taxtPayment }}</label> </td> 
                            
                        </tr>
                        <tr>
                            <td class="bg-light-gray"> <label for="month"><b>Banking Service Charge | බැංකුව මගින් අය කරනු ලබන සේවා ගාස්තු  </b></label></td>
                            <td ><label for="Uname">{{ bankfee }}</label> </td> 
                            
                        </tr>
                        <tr>
                            <td class="bg-light-gray"> <label for="month"><b>Gand Total | ගෙවිය යුතු මුළු මුදල </b></label></td>
                            <td ><label for="Uname">{{ grandPayTotal}}</label> </td> 
                            
                        </tr>
                        <tr>
                            <td class="bg-light-gray"><label for="rdes"><b>Description  | ගෙවීම් විස්තරය</b> </label></td>
                            <td ><label for="Uname">{{ remark }}</label></td>
                        </tr>
                    </tbody>
                </table>
                </div>
              
            <br>
            <div class="table-responsive">  
                <h6><input type="checkbox" id="checkid" v-model="checkVal"  >&nbsp;I certify that the above information is true and correct.| ඉහත තොරතුරු සත්‍ය හා නිවැරදි බවට සහතික කරමි. </h6>
                </div>

                <!-- Security Verification (CAPTCHA) -->
                <div class="table-responsive captcha-block" v-if="checkVal">
                    <h6><b>Security Verification | ආරක්‍ෂක සත්‍යාපනය</b></h6>
                    <p class="captcha-hint">Enter the code shown below to enable payment | පහත දක්වා ඇති කේතය ඇතුළත් කරන්න</p>

                    <div class="captcha-row">
                        <div class="captcha-canvas-wrap">
                            <canvas ref="captchaCanvas" width="160" height="55" class="captcha-canvas"></canvas>
                            <button type="button" class="captcha-refresh-btn" @click="refreshCaptcha" title="Get a new code">&#8635;</button>
                        </div>

                        <input
                            type="text"
                            v-model="captchaInput"
                            @input="onCaptchaInput"
                            class="form-control captcha-input"
                            placeholder="Enter code"
                            autocomplete="off"
                            maxlength="6"
                        />

                        <span v-if="captchaVerified" class="captcha-ok">&#10003; Verified</span>
                        <span v-else-if="captchaError" class="captcha-bad">Incorrect code, try again</span>
                    </div>
                </div>

                <div class="form-group aling"  v-if="theSabhaData && theSabhaData[0] && theSabhaData[0].saba_ipg=='BOC'">
                    <button class="btn " id="payboc"  type="submit" :disabled="disableButton">Pay Now</button>
                </div>
            </form><br>
           
                <div v-html="form" id="formResponse" class="form-group aling" style="display: none;"></div><br>

                <!-- <div id="embed-target"> </div> -->
                <!-- <input class="form-group aling" type="button" value="Pay with Embedded Page" onclick="Checkout.showEmbeddedPage('#embed-target');" /> -->
        <!-- <input class="form-group aling" type="button" value="Pay with Payment Page" onclick="this.Checkout.showPaymentPage();" /> -->
        <!-- <input class="form-group aling" type="button" value="Pay with Payment Page" @click="showPaymentPage" /> -->
        </div>
    </div>
</section>
</template>


<script>

// import router from "@/router";
import axios from "axios";
import { mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
   
    name: "AssessmentTaxInvoice",
  
    data() {
        return {
                   
                        // Sname:'scsad',
                        grandPayTotal:0,bankfee:0,
                        cusName:'',Sname:'',
                        monthName:'',
                        checkVal:'',
                        sessionData:'',
                        InvouceNum:'',sabha_code:'',remark:'',taxtPayment:'',taxNo:'',
                        pay_head:0,
                        nextid:'',
                        Nic:'',
                        payamount:{},
                        theSabhaData:[],
                        matchUser:undefined,
                        matchPaymonth:[],
                        onlinPaydata:[],
                        shopDeID:[],
                        temp:[],
                        AllShopDtails:[],
                        postData: {
                            mid:'',
                            paytype:'',
                            amount:'',
                            referenceNumber: '',
                            email:'',
                            bill_to_forename:'',
                            bill_to_surname:'',
                            bill_to_address_line1:'',
                            // bill_to_address_line2:'',
                            bill_to_address_city:'',
                            bill_to_address_state:'',
                            bill_to_address_postal_code:'',
                            bill_to_address_country:'LK',
                        },
                        response: null,
                        error: null,
                        currentDate: new Date(),
                        // date:new Date(),
                       fine:0,totalshoprent:0,
                       Checkout: null,
                       pay_vote:'other',
                       ward:'',
                       street:'',
                       formData: {
                            boc_sid : '',
                            boc_paytype: '',
                            boc_amount: '',
                            boc_grandamount:'',
                            boc_cus_nic: '',
                            boc_invoice: '',
                            boc_remarks:'',
                            country:'',
                            street :'',
                            street2 :'',
                            city :'',
                            state :'',
                            zip :'',

                        },
                        ipg:'',
                        disableButton:true,
                        // serverDate: null

                        // ── CAPTCHA state ──
                        captchaCode:'',
                        captchaInput:'',
                        captchaVerified:false,
                        captchaError:false,
        
                        
                       
        }
    },
          
        created() {
            this.getSessionData();
        //    this.LoadData();
           this.ShowMonthName();
        //    this.getshopdata();
        },
       
        computed : {
            ...mapState(["user"]),

             
         },

        watch: {
            // Fires only AFTER Vue has actually applied the v-model change —
            // unlike mounted() (canvas doesn't exist yet, checkVal starts false)
            // or a click handler on the checkbox (which would fire BEFORE
            // v-model's change event updates checkVal). This is also the single
            // place that decides whether the People's Bank form / BOC button
            // are allowed to show — both now require checkVal AND captchaVerified,
            // not just checkVal.
            checkVal(newVal) {
                if (newVal) {
                    // Box just became checked — draw the first code now that the
                    // captcha-block is in the DOM.
                    this.refreshCaptcha();
                } else {
                    this.captchaVerified = false;
                    this.captchaInput = '';
                    this.captchaError = false;
                }
                this.updateButtonState();
            },
            captchaVerified() {
                this.updateButtonState();
            },
        },
         
    methods: {
        ...mapMutations(["setUser"]),

        formattedDate() {
           
           let date = new Date()
           const year = date.getFullYear();
     const month = String(date.getMonth() + 1).padStart(2, '0');
     const day = String(date.getDate()).padStart(2, '0');
   const fdate=`${year}-${month}-${day}`;
   const options = { timeZone: 'Asia/Colombo', year: 'numeric', month: '2-digit', day: '2-digit' };
   return fdate.toString('en-US', options);
   //   return `${year}-${month}-${day}`;
         },

        async MatchUser(nic) {
            let data = await axios.get('/customersdata/' + nic);
            this.matchUser = data.data;
        },
       
  

  
       async getSessionData(){
        
        const data=JSON.parse(sessionStorage.getItem('payDetails'));
            if(data){
                // this.cus_nic=data.cus_nic
                this.sabha_code=data.sabha_code
                this.remark=data.remark
              
                this.taxtPayment=data.taxtPayment
                // this.payamount=data.payamount
                this.InvouceNum=data.invoiceNum

            }
            this.sessionData=data;
            // this.payamount=JSON.parse(sessionStorage.getItem('payamounts'));
            const nicdata=JSON.parse(sessionStorage.getItem('Userdata'));
            if(nicdata){
                this.Nic=nicdata.Unic
            }
            await this.MatchUser(this.Nic);
            this.setUser(this.matchUser);
            // let lastGennum=null
        if(this.sessionData){

            this.theSabhaData = (await axios.get('/PraSabhadata/' + this.sabha_code)).data

            this.Sname='other'
            this.ipg= this.theSabhaData[0].saba_ipg

            // this.AllShopDtails = (await axios.get('/shopdata/'+this.shopDeID )).data;
            let datau = await axios.get('/customersdata/' + this.user.cus_nic);
            this.matchUser = datau.data;
            this.cusName=this.matchUser.cus_name;
           
            // lastGennum=parseInt(this.onlinPaydata[0].gen_num);
           
            // this.InvouceNum= (this.sabha_code.concat(this.currentDate.getMonth(),this.currentDate.getFullYear(),lastGennum));
            // // this.InvouceNum='PRS571120232'
            // this.nextid= lastGennum+1;

            //         const genInvNum = {
            //             gen_num:this.nextid,
            //        }
            // await axios.put('/genaratenum/',genInvNum);
           
           if(this.user){
          
            if(this.ipg=='BOC'){
                this.bankfee=(parseFloat(this.taxtPayment)*((100/(100-1))-1)).toFixed(2)

            }
            if(this.ipg=='people'){
                 this.bankfee=(parseFloat(this.taxtPayment)*0.01).toFixed(2)
            }

                this.grandPayTotal=(parseFloat(this.bankfee)+parseFloat(this.taxtPayment)).toFixed(2)
            const datatax = {
                        other_pay_cus_nic :this.user.cus_nic,
                        other_pay_invoice_num  :this.InvouceNum,
                        other_pay_sabha_code :this.sabha_code,
                        other_pay_description: this.remark,
                        other_pay_price:this.taxtPayment
                   }
                   await axios.post("/otherpaymentstemp/",datatax);
                
           const onlineData = {
                   online_cus_nic:this.user.cus_nic,
                   online_sabha_code:this.sabha_code,
                   online_invoice_num:this.InvouceNum,
                   online_pay_amount:this.taxtPayment,
                   online_pay_month:0,
                   online_pay_year:0,
                   online_pay_des:this.remark,
                   pay_type:"other",
                   vote:this.pay_vote,
                   online_pay_date:this.formattedDate()
                   
               // ... other key-value pairs
                   };
                   await axios.post("/onlinepaymenttemp/",onlineData);

           }
           this.postData.mid=this.sabha_code,
           this.postData.paytype='other',
            this.postData.amount=this.grandPayTotal,
            this.postData.referenceNumber=this.InvouceNum,
            this.postData.email=this.user.cus_email,
            this.postData.bill_to_forename=this.user.cus_nic,
            this.postData.bill_to_surname=this.user.cus_name,
            this.postData.bill_to_address_line1=this.user.cus_address,
            // this.postData.bill_to_address_line2=this.user.cus_address,
            this.postData.bill_to_address_city=this.Sname,
            this.postData.bill_to_address_country='LK',
            
      axios
    //   .post('/processpaymentboc', this.postData, {
        .post('/process-payment', this.postData, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          this.response = response.data;
        
        //   alert("response");
        //   alert(response.data);
          document.getElementById('formResponse').innerHTML=response.data;
          document.getElementById('submit').style.display="none";
        })
        .catch((error) => {
          this.error = error;
        }); 
    }else{
        // this.$router.push("/shoprentexist");
        this.$router.push('/otherpayments');
    }

        },
///////////////////////////BOC GATE WAY//////////////////////
        submitForm() {
            // Hard guard: never allow submission unless certified AND captcha verified,
            // even if the disabled attribute were bypassed client-side.
            if(!this.checkVal || !this.captchaVerified){
                this.disableButton = true;
                return;
            }

                            this.formData.boc_sid =this.sabha_code
                            this.formData.boc_paytype='other'
                            this.formData.boc_amount=this.Totalpayamount
                            this.formData.boc_grandamount=this.grandPayTotal
                            this.formData.boc_cus_nic=this.user.cus_nic
                            this.formData.boc_invoice=this.InvouceNum
                            this.formData.boc_remarks=this.remark
                            this.formData.country='LKA'
                            this.formData.street ='25466'
                            this.formData.street2 =this.Sname
                            this.formData.city ='25466'
                            this.formData.state ='25466'
                            this.formData.zip ='25466'   

        console.log("this.sabha_code",this.sabha_code);
        //   axios.post('http://localhost:3000/api/bocpay/', this.formData)
//         const storedBackendUrl =
//   window.sessionStorage.getItem("backendUrl") ||
//   "https://elgservices.com.lk/api";

const storedBackendUrl =
  window.sessionStorage.getItem("backendUrl") ||
  "https://elgservices.lk/api";

      axios.post(storedBackendUrl+'/bocpay/', this.formData)
        .then(response => {
        // window.location.href = "https://test-bankofceylon.mtf.gateway.mastercard.com/checkout/pay/"+response.data.sessionid+"?checkoutVersion=1.0.0"   // test url
         window.location.href = "https://bankofceylon.gateway.mastercard.com/checkout/pay/"+response.data.sessionid+"?checkoutVersion=1.0.0" // production url

          console.log(response.data.sessionid);
        })
        .catch(error => {
          console.error(error);
        });
    },   
      

        
        // scrollToTop() {
        //     window.scrollTo(0, 0);
        // },
     
        
        getMonthName:function (monthNumber) {
            const date = new Date();
            date.setMonth(monthNumber);

            return date.toLocaleString('en-US', { month: 'long' });
            },

        ShowMonthName(){
            this.monthName=this.getMonthName(this.month);
        },

        // ── CAPTCHA methods ──

        generateCaptchaCode(length = 6) {
            // Excludes visually-confusable characters: 0/O, 1/I/L
            const chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
            let code = '';
            for (let i = 0; i < length; i++) {
                code += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return code;
        },

        drawCaptcha(code) {
            const canvas = this.$refs.captchaCanvas;
            if (!canvas) return;
            const ctx = canvas.getContext('2d');
            const w = canvas.width, h = canvas.height;

            ctx.clearRect(0, 0, w, h);

            ctx.fillStyle = '#f7f7f7';
            ctx.fillRect(0, 0, w, h);

            for (let i = 0; i < 6; i++) {
                ctx.strokeStyle = `rgba(98,10,10,${0.15 + Math.random() * 0.2})`;
                ctx.lineWidth = 1;
                ctx.beginPath();
                ctx.moveTo(Math.random() * w, Math.random() * h);
                ctx.lineTo(Math.random() * w, Math.random() * h);
                ctx.stroke();
            }

            const spacing = w / (code.length + 1);
            for (let i = 0; i < code.length; i++) {
                const x = spacing * (i + 1);
                const y = h / 2 + (Math.random() * 10 - 5);
                const angle = (Math.random() * 30 - 15) * (Math.PI / 180);

                ctx.save();
                ctx.translate(x, y);
                ctx.rotate(angle);
                ctx.font = `700 ${24 + Math.floor(Math.random() * 4)}px Arial, sans-serif`;
                ctx.fillStyle = '#620a0a';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(code[i], 0, 0);
                ctx.restore();
            }

            for (let i = 0; i < 25; i++) {
                ctx.fillStyle = `rgba(98,10,10,${Math.random() * 0.3})`;
                ctx.beginPath();
                ctx.arc(Math.random() * w, Math.random() * h, 1, 0, 2 * Math.PI);
                ctx.fill();
            }
        },

        refreshCaptcha() {
            this.captchaCode = this.generateCaptchaCode();
            this.captchaInput = '';
            this.captchaVerified = false;
            this.captchaError = false;
            this.updateButtonState();
            this.$nextTick(() => this.drawCaptcha(this.captchaCode));
        },

        onCaptchaInput() {
            this.captchaError = false;
            const entered = (this.captchaInput || '').trim().toUpperCase();
            if (entered.length === this.captchaCode.length) {
                if (entered === this.captchaCode) {
                    this.captchaVerified = true;
                } else {
                    this.captchaVerified = false;
                    this.captchaError = true;
                    // Rotate the code after a wrong attempt so it can't be brute-forced visually.
                    setTimeout(() => this.refreshCaptcha(), 800);
                }
            } else {
                this.captchaVerified = false;
            }
            this.updateButtonState();
        },

        updateButtonState() {
            const ready = this.checkVal === true && this.captchaVerified === true;
            this.disableButton = !ready;

            // The People's Bank flow has no dedicated Vue-rendered button — the
            // gateway HTML/form injected into #formResponse (built in
            // getSessionData()) IS its "pay" button. It must stay hidden until
            // the user has both certified AND passed the captcha, same as the
            // BOC button above.
            const formResponseEl = document.getElementById('formResponse');
            if (formResponseEl) {
                formResponseEl.style.display = ready ? 'block' : 'none';
            }
        },

    },
}
</script>





<style scoped>
.register-container {
    padding: 1.5rem 9%;
    min-height: 80vh;
   background-image: url("../assets/images/regbacground.jpg");
  background-repeat: no-repeat;
  background-size:cover;
}

.register-container .register-form-container {
    background: #ffffffe9;

}

/* .register-container .register-form-container form {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0%);
    max-width: 70rem;
    width: 100%;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.05);
    border: 0.1rem solid rgba(0, 0, 0, 0.2);
    padding: 1rem;
    border-radius: 0.5rem;
    animation: fadeUp 0.4s linear;
} */

.register-container .register-form-container form h3 {
    /* padding-bottom: 0.1rem; */
    font-size: 1.9rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: center;
    
}

.register-container .register-form-container form h4 {
    /* padding-bottom: 0.2rem; */
    font-size: 1.6rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: left;
    
}

.register-container .register-form-container form h5 {
    padding-bottom: 0.2rem;
    font-size: 1.4rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: left;
    
}

.register-container .register-form-container  pre {
    /* padding-bottom: 0.2rem; */
    font-size: 1.0rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: right;
    padding-top: 1%;
    padding-right: 2%;
    
}
.register-container .register-form-container form h6 {
    /* padding-bottom: 0.2rem; */
    font-size: 1.25rem;
    /* text-transform: uppercase; */
    color: #130f40;
    /* margin: 0; */
    text-align: left;
    
}
.register-container .register-form-container form .form-control {
    margin: 0.7rem 0;
    border-radius: 0.5rem;
    /* background: #f7f7f7; */
    /* padding: 2rem 1.2rem; */
    font-size: 1.5rem;
    color: #130f40;
    text-transform: none;
    width: 100%;
    border: none;
   
}

.register-container .register-form-container form label {
    font-size: 1.5rem;
    margin: 0;
    padding: 0.6rem;
}

.register-container .register-form-container form span {
    font-size: 25px;
    /* padding-left: 5px;
    padding-right: 40px; */
    text-align: center;
    color: #620a0a;
}


.register-container .register-form-container form .btn {
    margin: 1rem 0;
    width: 20%;
    text-align: center;
    align-items: center;
    background: #620a0a;
    
}


.register-container .register-form-container form p {
    padding-top: 0.75rem;
    font-size: 1rem;
    color: #666;
    margin: 0;
}

.register-container .register-form-container form p a {
    color: #27ae60;
}

.register-container .register-form-container form p a:hover {
    color: #130f40;
    text-decoration: underline;
}

.register-container .register-form-container form .form-group  {
    margin: 0;
}

.register-container .register-form-container form .form-group  .error-mess {
    font-size: 5rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 0;
    padding: 0;
    width: 100%;

}

 .heading{
    padding: 0;
 }
/* Table */
.bg-light-gray {
    background-color: #f7f7f7;
}

.table thead th {
    vertical-align: bottom;
    border-bottom: 0px solid #dee2e6;
    font-size: 0.5rem;
}
label{

    font-size: 0.2rem;
}

.table-responsive{
    padding-left: 3.5rem;
    width: 95%;
  /* align:center; */
}

.table-responsive1{
    padding-left: 8rem;
    /* width: 95%; */
  /* align:center; */
}
.table1{
  align-items: center;
    width: 90%;
    font-size:small;
   
  /* align:center; */
}
.table1 td
 {
    padding: .25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
    width: auto;
    text-align: center;
} 
.table td,
.table th {
    padding: .25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    width: 30%;
} 
.aling{
    align-items: center;
    text-align: center;
align-content: center;
/* padding-right: 15%; */
}

/* ── CAPTCHA block ── */
.captcha-block {
    margin-bottom: 1rem;
}
.captcha-hint {
    font-size: 1.1rem;
    color: #666;
    margin: 0.2rem 0 0.8rem;
}
.captcha-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
}
.captcha-canvas-wrap {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #f7f7f7;
    border: 1px solid #dee2e6;
    border-radius: 0.4rem;
    padding: 0.3rem;
}
.captcha-canvas {
    display: block;
    border-radius: 0.3rem;
}
.captcha-refresh-btn {
    width: 2.2rem;
    height: 2.2rem;
    border-radius: 0.4rem;
    border: 1px solid #dee2e6;
    background: #fff;
    cursor: pointer;
    font-size: 1.2rem;
    color: #620a0a;
    line-height: 1;
}
.captcha-refresh-btn:hover {
    background: #eee;
}
.captcha-input {
    width: 10rem !important;
    font-size: 1.3rem !important;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    padding: 0.6rem 1rem !important;
    border: 1.5px solid #dee2e6 !important;
    border-radius: 0.4rem !important;
}
.captcha-ok {
    color: #27ae60;
    font-weight: bold;
    font-size: 1.1rem;
}
.captcha-bad {
    color: #c0392b;
    font-weight: bold;
    font-size: 1.1rem;
}
</style>